import axios from "axios";
import { create } from "zustand";
import { SignedInSessionResource } from "@clerk/types";
import { getUnexpiredToken } from "@/utils/utils";
export type SubscriptionTier =
  | "free"
  | "pro"
  | "scale"
  | "ultimate"
  | "unlimited"
  | "new_pro"
  | "new_scale"
  | "new_ultimate"
  | "new_power"
  | "new_unlimited"
  | null;

export interface AiUsage {
  total_input_tokens_period: number;
  total_output_tokens_period: number;
  total_input_tokens_today: number;
  total_output_tokens_today: number;
  total_prompts_period: number;
  total_prompts_today: number;
}

export interface PlanInfoStore {
  subscriptionTier: SubscriptionTier;
  usage: AiUsage;
  current_period_start: Date;
  current_period_end: Date;
  promptPackages: {
    id: string;
    created_at: string;
    auth0_user_id: string;
    num_prompts: number;
    payment_intent_id: string;
    prompts_used: number;
  }[];

  refreshPlanInfo: (
    session?: SignedInSessionResource | null,
    supabaseJWT?: string | null,
  ) => Promise<void>;

  referral: string | null;
  fetchReferral: () => void;

  showUpgradeModal: boolean;
  setShowUpgradeModal: (show: boolean) => void;
}

const usePlanInfoStore = create<PlanInfoStore>((set, get) => ({
  subscriptionTier: null,
  // @ts-expect-error TS2322
  usage: null,
  // @ts-expect-error TS2322
  current_period_start: null,
  // @ts-expect-error TS2322
  current_period_end: null,
  promptPackages: [],

  refreshPlanInfo: async (session?: SignedInSessionResource | null) => {
    if (!session) {
      return;
    }

    const token = await getUnexpiredToken(session);

    try {
      const res = await axios.get(
        `${import.meta.env.VITE_BACKEND_BASE_URL}/stripe/plan-info`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      set({
        subscriptionTier: res.data.status,
        usage: res.data.usage,
        // @ts-expect-error TS2322
        current_period_start: res.data.current_period_start
          ? new Date(res.data.current_period_start)
          : null,
        // @ts-expect-error TS2322
        current_period_end: res.data.current_period_end
          ? new Date(res.data.current_period_end)
          : null,
        promptPackages: res.data.prompt_packages,
      });
    } catch (e) {
      console.error(e);
    }
  },

  referral: null,
  fetchReferral: async () => {
    if (typeof window !== "undefined" && (window as any).rewardful) {
      (window as any).rewardful("ready", function () {
        set({ referral: (window as any).Rewardful.referral });
      });
    }
  },

  showUpgradeModal: false,
  setShowUpgradeModal: (show: boolean) => {
    set({ showUpgradeModal: show });
  },
}));

export default usePlanInfoStore;
